import React from 'react';
import AuditLogEdit from './AuditLogEdit';

const AuditLogList = () => <AuditLogEdit />;

export default AuditLogList;